import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { siteMetadata as siteConfig } from '../../gatsby-config';

import '../styles/main.less';
import { SITE_ROOT } from '../utils/navigation';
import 'prismjs/themes/prism.css';

export default class Template extends React.Component {
    static propTypes = {
        children: PropTypes.any,
    };

    render() {
        const { children } = this.props;

        const htmlAttributes = {
            lang: 'en',
        };

        const base = {
            href: `${SITE_ROOT}/`,
            target: '_blank',
        };

        const meta = [
            {
                property: 'og:locale',
                content: 'en_US',
            },
            {
                property: 'og:site_name',
                content: 'Smooch Documentation',
            },
            {
                property: 'og:image',
                content: '/sm_logo_fb.jpg',
            },
            {
                name: 'msapplication-TileColor',
                content: '#ffffff',
            },
            {
                name: 'msapplication-TileImage',
                content: '/ms-icon-144x144.png',
            },
            {
                name: 'theme-color',
                content: '#912d8d',
            },
        ];

        const link = [
            {
                rel: 'apple-touch-icon',
                sizes: '57x57',
                href: '/apple-icon-57x57.png',
            },
            {
                rel: 'apple-touch-icon',
                sizes: '60x60',
                href: '/apple-icon-60x60.png',
            },
            {
                rel: 'apple-touch-icon',
                sizes: '72x72',
                href: '/apple-icon-72x72.png',
            },
            {
                rel: 'apple-touch-icon',
                sizes: '76x76',
                href: '/apple-icon-76x76.png',
            },
            {
                rel: 'apple-touch-icon',
                sizes: '114x114',
                href: '/apple-icon-114x114.png',
            },
            {
                rel: 'apple-touch-icon',
                sizes: '120x120',
                href: '/apple-icon-120x120.png',
            },
            {
                rel: 'apple-touch-icon',
                sizes: '144x144',
                href: '/apple-icon-144x144.png',
            },
            {
                rel: 'apple-touch-icon',
                sizes: '152x152',
                href: '/apple-icon-152x152.png',
            },
            {
                rel: 'apple-touch-icon',
                sizes: '180x180',
                href: '/apple-icon-180x180.png',
            },
            {
                rel: 'icon',
                sizes: '16x16',
                href: '/favicon-16x16.png',
            },
            {
                rel: 'icon',
                sizes: '32x32',
                href: '/favicon-32x32.png',
            },
            {
                rel: 'icon',
                sizes: '96x96',
                href: '/favicon-96x96.png',
            },
            {
                rel: 'icon',
                sizes: '192x192',
                href: '/android-icon-192x192.png',
            },
            {
                href: 'https://fonts.googleapis.com/css?family=Roboto+Mono',
                rel: 'stylesheet',
            },
            {
                href: 'https://cdn.jsdelivr.net/npm/docsearch.js@2/dist/cdn/docsearch.min.css',
                rel: 'stylesheet',
            },
        ];

        const script = [
            {
                type: 'text/javascript',
                innerHTML: `
                (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
                })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

                ga('create', 'UA-47399515-1', 'auto');
                ga('require', 'urlChangeTracker');
                ga('send', 'pageview');
            `,
            },
            {
                type: 'text/javascript',
                src: 'https://cdn.jsdelivr.net/npm/docsearch.js@2/dist/cdn/docsearch.min.js',
            },
        ];

        return (
            <div>
                <Helmet
                    htmlAttributes={htmlAttributes}
                    titleTemplate={`${siteConfig.title} | %s`}
                    defaultTitle="Documentation"
                    base={base}
                    link={link}
                    script={script}
                    meta={meta}
                />
                {children}
            </div>
        );
    }
}
